import Modal from "../../../../modal";
import Checkbox from "../../../../checkbox";
import { Select, Option } from "../../../../select";
import styles from "./styles.module.css";
import { useState, useContext, useEffect } from "react";
import Table from "../../../../editors/table";
import { DatabaseValue } from "../../../../contexts/database";
import { MdEdit } from "react-icons/md";
import { AppDisbatch } from "../../../../contexts/app";
export default function EditPage({ pageNames = [], page }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(page.name);
  const [dynamic, setDynamic] = useState(false);
  const [dynamicValue, setDynamicValue] = useState({
    type: "user",
    slug: "_id",
  });
  const [_delete, _setDelete] = useState(false);

  const disbatch = useContext(AppDisbatch);

  useEffect(() => {
    if (page.dynamic) {
      setDynamicValue(page.dynamic);
      setDynamic(true);
    } else {
      setDynamicValue({
        type: "user",
        slug: "_id",
      });
      setDynamic(false);
    }
  }, [page]);

  const handleClick = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleSavePage = async (e) => {
    e.preventDefault();
    const allowed = /^[a-z\-]+$/.test(name);

    if (!allowed) {
      alert("Please Format the Page Name Correctly");
      return;
    }

    if (pageNames.includes(name) && page.name !== name) {
      alert("Sorry, a page with that name already exists");
      return;
    }
    try {
      const _page = { ...page };
      _page.name = name;
      _page.dynamic = dynamic ? dynamicValue : null;
      disbatch({ type: "setPage", value: _page });
      setOpen(false);
    } catch (err) {
      console.log(err);
      alert("sorry, we ran into a bug and couldn't create a new page");
    }
  };

  const handleDelete = () => {
    disbatch({ type: "deletePage", value: page });
  };
  return (
    <>
      <MdEdit className={styles.editIcon} onClick={handleClick} />
      <Modal open={open} onClose={() => setOpen(false)}>
        <div onMouseDown={(e) => e.stopPropagation()} className={styles.modal}>
          <div className={styles.modalTitle}>Edit Page</div>
          <div className={styles.inputTitle}>Page Name</div>
          <input
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className={styles.hint}>
            Should be all lowercase and only contain a-z or -
          </div>
          <div style={{ marginTop: 20 }} className={styles.inputTitle}>
            Make this page path dynamic?
          </div>
          <Checkbox checked={dynamic} onChange={setDynamic} />
          {dynamic && (
            <DynamicSection value={dynamicValue} onChange={setDynamicValue} />
          )}
          <button onClick={handleSavePage} className={styles.add}>
            Save
          </button>
          <div style={{ marginTop: 20 }} className={styles.inputTitle}>
            Danger Zone
          </div>
          {!_delete ? (
            <button onClick={() => _setDelete(true)} className={styles.delete}>
              Delete Page
            </button>
          ) : (
            <ConfirmDelete
              onClick={handleDelete}
              onCancel={() => _setDelete(false)}
            />
          )}
        </div>
      </Modal>
    </>
  );
}

const ConfirmDelete = ({ onClick, onCancel }) => {
  return (
    <>
      <div className={styles.hint}>Are you sure? This can't be undone.</div>
      <button onClick={onClick} className={styles.delete}>
        Yes, Delete this page
      </button>
      <div
        style={{ fontSize: 14, cursor: "pointer", textAlign: "center" }}
        onClick={onCancel}
      >
        Cancel
      </div>
    </>
  );
};

const DynamicSection = ({ value, onChange }) => {
  const [fields, setFields] = useState([]);
  const tables = useContext(DatabaseValue);
  const handleTableChange = (v) => {
    onChange({ ...value, type: v, slug: "_id" });
  };
  const handleSlugChange = (v) => {
    onChange({ ...value, slug: v });
  };

  useEffect(() => {
    const selected = tables.find((t) => t.id === value.type);
    if (selected) {
      const fields = Object.keys(selected.fields)
        .map((key) => ({ ...selected.fields[key], id: key }))
        .filter((x) => x.type === "Text");
      setFields(fields);
    }
  }, [value, tables]);

  return (
    <div className={styles.dynamicSection}>
      <div className={styles.inputTitle}>Data table of page</div>
      <Table value={value.type} onChange={handleTableChange} />
      <div style={{ marginTop: 12 }} className={styles.inputTitle}>
        Field to use as slug
      </div>
      <Select value={value.slug} onChange={handleSlugChange}>
        {fields.map((f) => {
          return (
            <Option key={f.id} value={f.id}>
              {f.name}
            </Option>
          );
        })}
      </Select>
    </div>
  );
};
